// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"3b0138e2","238":"53fc718e","297":"7b42cbc9","452":"95cfa0ef","961":"a3484e16"}[chunkId] + ".chunk.js";
};